import riskApi from '@Apis/risks.api';
import { Category, ComponentMetadata, ComponentField } from '@Types';

export const getCoFConfigApi = () => {
	const address = '/cof/config';
	return riskApi.get<Category[]>(address);
};

export const saveCoFApi = (config: Category[]) => {
	const address = '/cof/config';
	return riskApi.put<Category>(address, config);
};

export const getCoFFieldsApi = (assetType: string) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=cof`;
	return riskApi.get<ComponentField[], string>(address);
};

export const getCoFComponentProximityMetadataApi = (assetType: string) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=}&fieldType=${encodeURIComponent(
		'cof/proximity',
	)}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getProximityAttributeFieldsApi = (assetType: string) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=proximityAttribute`;
	return riskApi.get<ComponentField[], string>(address);
};

export const getCustomTableFieldsApi = (assetType: string) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=customTable`;
	return riskApi.get<ComponentField[], string>(address);
};

export const getCoFComponentAssetMetadataApi = (
	assetType: string,
	param: string,
) => {
	const address = `/cof/field/score?assetType=${assetType}&fieldName=${param}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getCoFComponentProximityAttrMetadataApi = (
	assetType: string,
	fieldName: string,
	layerName: string,
) => {
	const address = `/cof/field/score?assetType=${assetType}&fieldName=${fieldName}&layerName=${layerName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getCoFComponentCustomTableMetadataApi = (
	assetType: string,
	fieldName: string,
	tableName: string,
) => {
	const address = `/cof/field/score?assetType=${assetType}&fieldName=${fieldName}&tableName=${tableName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getCoFComponentTaskMetadataApi = (
	assetType: string,
	fieldName: string,
	tableName: string,
) => {
	const address = `/cof/field/score?assetType=${assetType}&fieldName=${fieldName}&taskType=${tableName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};
